// extracted by mini-css-extract-plugin
export default {"searchInputBox":"searchInput_searchInputBox__4ZCBG","inputFocus":"searchInput_inputFocus__MiB6h"};